import * as percentMin from './datiq-input-percent-min.validator';
import * as percentMax from './datiq-input-percent-max.validator';

const DatiqInputValidators = {
    ...percentMin,
    ...percentMax,
};

export { DatiqInputValidators };
